import {immerable} from 'immer';

import {LegalDocument} from '../../dal';

export class LegalStoreModel {
    [immerable] = true;

    documents: LegalDocument[] = [];
    loaded = false;

    onDocumentsLoaded(documents: LegalDocument[]): void {
        this.documents = [...documents];
        this.loaded = true;
    }
}
